import React from "react";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Button,
    ThemeProvider,
    useTheme
} from "@mui/material";
import { DialogTheme } from "../styles/DialogTheme";

const QuickStartDialog = ({ open, onClose, pdfUrl }) => {
    const theme = useTheme();

    return (
        <ThemeProvider theme={DialogTheme(theme)}>
            <Dialog open={open} onClose={onClose} maxWidth="xl" fullWidth>
                <DialogTitle>Quick Start Guide</DialogTitle>
                <DialogContent>
                    <iframe
                        title={"Quick Start Guide"}
                        src={`${pdfUrl}#toolbar=0&navpanes=0`}
                        width="100%"
                        height="3000px" // Set a large height since iframe content height is unrecognisable
                    ></iframe>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={onClose}
                        variant="contained"
                        color="primary"
                    >
                        CLOSE
                    </Button>
                </DialogActions>
            </Dialog>
        </ThemeProvider>
    );
};

export default QuickStartDialog;
